import { AxiosInstance } from 'axios';
import Vue from 'vue';
import { UserManager, WebStorageStateStore, User } from 'oidc-client';
import { profileModule } from '@/store/profile';

export class LoginService {
    public publicAxiosInstance: AxiosInstance;
    public authAxiosInstance: AxiosInstance;
    private userManager: UserManager;

    constructor() {
        const STS_DOMAIN: string = `${Vue.$env().IdentityEndpoint}`;

        const settings: any = {
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            authority: STS_DOMAIN,
            client_id: 'middleware-portal',
            redirect_uri: `${Vue.$env().PortalUrl}callback.html`,
            automaticSilentRenew: true,
            silent_redirect_uri: `${Vue.$env().PortalUrl}silent-renew.html`,
            response_type: 'code',
            scope: 'openid roles profile directory.all bright-sync.api bright-sync.middleware',
            post_logout_redirect_uri: `${Vue.$env().PortalUrl}login`,
            filterProtocolClaims: true,
        };

        this.userManager = new UserManager(settings);

        this.userManager.events.addUserLoaded(async (user) => {
            profileModule.setUser(user);
        });

        this.userManager.events.addSilentRenewError((error) => {
            console.log(error);
            console.error('KAPOT');
            // custom logic here
        });
    }

    public async isLoggedIn(): Promise<boolean> {
        const user = await this.getUser();
        const loggedIn = user != null && !user.expired;
        return loggedIn;
    }

    public async accessTokenExpired(): Promise<boolean> {
        const user = await this.getUser();
        const accessTokenExpired = user != null && user.expired;
        return accessTokenExpired;
    }

    public async getUser(): Promise<User> {
        const user = await this.userManager.getUser();
        return user;
    }

    public async login() {
        // Removes stale state entries in storage for incomplete authorize requests
        await this.clearStaleState();

        await this.userManager.signinRedirect();
    }

    public async logout() {
        await this.userManager.signoutRedirect({ post_logout_redirect_uri: `${Vue.$env().PortalUrl}login` });
    }

    public async refreshToken() {
        return await this.userManager
            .signinSilent()
            .then((response) => {
                console.log(response);
            })
            .catch((error) => {
                console.error(error);
                localStorage.removeItem(`oidc.user:${Vue.$env().IdentityEndpoint}:middleware-portal`);
                window.location.href = '/';
            });
    }

    public async clearStaleState() {
        await this.userManager.clearStaleState();
    }

    public isInRole(role: string): boolean {
        return profileModule.getRoles().indexOf(role) > -1;
    }
}
